function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.93877 6.3189C10.203 6.31641 10.4528 6.19794 10.6219 5.9949C10.8067 5.79805 10.9088 5.53771 10.9072 5.2677C10.9116 5.05944 10.8329 4.85798 10.6885 4.7079C10.5428 4.5591 10.3422 4.47704 10.1341 4.4811C9.87187 4.48101 9.62233 4.59382 9.44917 4.7907C9.26768 4.98603 9.16897 5.24411 9.17377 5.5107C9.16682 5.72317 9.24451 5.9297 9.38977 6.0849C9.53195 6.2362 9.73117 6.32078 9.93877 6.318V6.3189Z",
  fill: "#2DA92F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3781 11.377C10.2699 11.274 10.1001 11.274 9.99195 11.377C9.7377 11.6263 9.4671 11.8584 9.18195 12.0718C9.35942 11.1384 9.59721 10.2176 9.89385 9.31506C10.1115 8.73621 10.2669 8.13582 10.3574 7.52406C10.3618 7.33889 10.2808 7.16197 10.1378 7.04436C9.98932 6.93126 9.80573 6.87421 9.61935 6.88326C9.22362 6.90634 8.84037 7.03026 8.50605 7.24326C8.00396 7.55371 7.55284 7.93987 7.16865 8.38806C7.11601 8.44543 7.08993 8.52229 7.09678 8.59984C7.10363 8.6774 7.14278 8.7485 7.20465 8.79576L7.51065 9.03246C7.62069 9.11773 7.77682 9.1085 7.87605 9.01086C8.10119 8.7798 8.33949 8.56194 8.58975 8.35836C8.08671 9.75238 7.73519 11.1965 7.54125 12.6658C7.5311 12.8915 7.60922 13.1123 7.75905 13.2814C7.91256 13.4416 8.12677 13.5292 8.34855 13.5226C8.65341 13.5015 8.94778 13.4027 9.20355 13.2355C9.72279 12.8899 10.2053 12.4921 10.6435 12.0484C10.6988 11.996 10.73 11.9233 10.73 11.8472C10.73 11.7711 10.6988 11.6984 10.6435 11.6461L10.3781 11.377Z",
  fill: "#2DA92F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9C0 13.9706 4.02944 18 9 18C13.9683 17.9945 17.9945 13.9683 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9ZM1.09889 8.99999C1.09889 4.63634 4.63634 1.09889 8.99999 1.09889C13.3616 1.10385 16.8961 4.63839 16.9011 8.99999C16.9011 13.3637 13.3637 16.9011 8.99999 16.9011C4.63634 16.9011 1.09889 13.3637 1.09889 8.99999Z",
  fill: "#2DA92F"
});

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.ea9929c4.svg";
export { ForwardRef as ReactComponent };